/**
 * Contrôles de format des coordonnées bancaires, alignés sur ceux du back
 * (FinancierService : value objects `Iban` et `Bic`).
 */

const IBAN_LONGUEUR_MIN = 15;
const IBAN_LONGUEUR_MAX = 34;
const FORMAT_BIC = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

/** IBAN sans espaces et en majuscules. */
export function normaliserIban(iban: string | null | undefined): string {
  return (iban ?? '').replace(/\s/g, '').toUpperCase();
}

/** BIC sans espaces autour et en majuscules. */
export function normaliserBic(bic: string | null | undefined): string {
  return (bic ?? '').trim().toUpperCase();
}

/** Longueur, caractères alphanumériques et clé de contrôle (modulo 97 = 1). */
export function estIbanValide(iban: string | null | undefined): boolean {
  const normalise = normaliserIban(iban);
  if (normalise.length < IBAN_LONGUEUR_MIN || normalise.length > IBAN_LONGUEUR_MAX) {
    return false;
  }
  if (!/^[A-Z0-9]+$/.test(normalise)) {
    return false;
  }
  const reordonne = normalise.substring(4) + normalise.substring(0, 4);
  let reste = 0;
  for (const caractere of reordonne) {
    // A = 10, B = 11, ..., Z = 35
    const chiffres = /\d/.test(caractere) ? caractere : String(caractere.charCodeAt(0) - 55);
    for (const chiffre of chiffres) {
      reste = (reste * 10 + Number(chiffre)) % 97;
    }
  }
  return reste === 1;
}

/** 8 ou 11 caractères : banque (6 lettres), localisation (2), agence facultative (3). */
export function estBicValide(bic: string | null | undefined): boolean {
  return FORMAT_BIC.test((bic ?? '').toUpperCase());
}
